import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
}

/*
 * The shop's hook mark. The favicon (public/favicon.svg) is the same drawing.
 */
const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            className={cn('size-9 shrink-0', className)}
        >
            <rect width='32' height='32' rx='9' className='fill-primary' />

            <circle
                cx='19'
                cy='6.6'
                r='1.9'
                fill='none'
                strokeWidth='1.7'
                className='stroke-accent'
            />

            <path
                d='M19 8.6V19.5a5.5 5.5 0 0 1-11 0v-2.8l2.7 2.2'
                fill='none'
                strokeWidth='2.6'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='stroke-accent'
            />

            <path
                d='M5 27c2-1.4 4-1.4 6 0s4 1.4 6 0 4-1.4 6 0 4 1.4 4 0'
                fill='none'
                strokeWidth='1.6'
                strokeLinecap='round'
                className='stroke-lagoon'
            />
        </svg>
    )
}

export default BrandMark
